import { Notify } from "quasar";

const type = "negative";
const position = "bottom-right";

export function notifyError(err) {
  const message = "message" in err ? err.message : "" + err;
  if (message !== "Abort") {
    console.error(err);
    Notify.create({ type, message, position });
  }
}
